import React, { createContext, useContext, useState } from 'react';

// Create a context for the airport pickup data
const AirportPickupDataContext = createContext();

// Create a provider component
export const AirportPickupDataProvider = ({ children }) => {
    const [airportPickupData, updateAirportPickupData] = useState(null);

    return (
        <AirportPickupDataContext.Provider value={{ airportPickupData, updateAirportPickupData }}>
            {children}
        </AirportPickupDataContext.Provider>
    );
};

// Custom hook to use the AirportPickupDataContext
export const useAirportPickupData = () => {
    return useContext(AirportPickupDataContext);
};
